import server from "@/api/server";

/**
 * @param formData
 * @returns {Promise<{id: string, name: string, file_name:string}>}
 */
async function uploadFile(formData) {
  return await server.post("/file/upload", formData, {
    headers: {
      "Content-Type": "form/multipart"
    }
  });
}

export { uploadFile };
